"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_STATE_SUBSCRIBE = exports.URL_STATE_SHARE = exports.URL_STATE_PURCHASE = exports.URL_STATE_COMPLETE_PURCHASE = exports.URL_PARAM_PAYMENT_TYPE = exports.URL_PARAM_VIDEO_ID = exports.URL_PARAM_COMP_ID = exports.URL_PARAM_STATE = void 0;
exports.URL_PARAM_STATE = 'wix-vod-state';
exports.URL_PARAM_COMP_ID = 'wix-vod-comp-id';
exports.URL_PARAM_VIDEO_ID = 'wix-vod-video-id';
exports.URL_PARAM_PAYMENT_TYPE = 'paymentType';
exports.URL_STATE_COMPLETE_PURCHASE = 'purchase-complete';
exports.URL_STATE_PURCHASE = 'purchase';
exports.URL_STATE_SHARE = 'share';
exports.URL_STATE_SUBSCRIBE = 'subscribe';
//# sourceMappingURL=url.js.map